import Anamnesis from "components/containers/Anamnesis"
import Layout from "./Layout"

const AnamnesisPage = () => {
  return (
    <Layout>
      <Anamnesis />
    </Layout>
  )
}

export default AnamnesisPage
